import React from 'react'

import { observer } from 'mobx-react'

interface IProps {
  isAnyPopupOpened?: boolean
}

@observer
export default class OpacityBackground extends React.Component<IProps> {
  public render() {
    return this.props.isAnyPopupOpened ? (
      <div className="filter-container-background tw:absolute tw:top-full tw:right-0 tw:bottom-0 tw:left-0 tw:z-10 tw:h-screen tw:w-screen tw:bg-background tw:opacity-80" />
    ) : (
      <div className="no-grow" />
    )
  }
}
